import { ChangeDetectorRef, Component } from '@angular/core';
import { defaultNavigationOptions } from '../../../../entities/navigation/navigation-options.entity';

import { NavigationLink } from '@stylehaven/components';
import { combineLatest, Observable } from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { RecordNavigationService } from '../../../../services/navigation/record-navigation.service';
import { GetFieldPipe } from '../../../pipes/get-field.pipe';
import { TextCellComponent } from '../text-cell/text-cell.component';
import {RecordIdCellOptions} from "../../../entities/cell-options/cell-options.entity";

@Component({
    standalone: false,
    selector: 'digihaven-short-record-id-cell',
    templateUrl: './short-record-id-cell.component.html'
})
export class ShortRecordIdCellComponent extends TextCellComponent<RecordIdCellOptions> {
    navigationLink$!: Observable<NavigationLink>;
    linkEnabled$: Observable<boolean>;

    constructor(fieldPipe: GetFieldPipe, cd: ChangeDetectorRef, private navigationService: RecordNavigationService) {
        super(fieldPipe, cd);
        this.buildNavigationLink();
    }

    buildNavigationLink(): void {
        this.navigationLink$ = combineLatest([this.data$, this.overviewId$]).pipe(
            map(([record, overviewId]) => {
                return this.navigationService.getNavigationLink({
                    record,
                    navigationOptions: {
                        ...defaultNavigationOptions,
                        queryParams: {
                            ['overview']: overviewId
                        }
                    }
                });
            })
        );
        this.linkEnabled$ = this.options$.pipe(
            startWith({disableLink: false}),
            map(options => options === undefined || !options.disableLink)
        );
    }
}
